var map = {
	"./Auths/business-setup.jsx": [
		88027
	],
	"./Auths/change-password.jsx": [
		61511
	],
	"./Auths/email-otp.jsx": [
		41333
	],
	"./Auths/payment.jsx": [
		45932
	],
	"./Auths/pricing.jsx": [
		91671,
		671
	],
	"./Auths/reset-password.jsx": [
		15780
	],
	"./Auths/signup-verify-otp.jsx": [
		25375
	],
	"./Auths/signup.jsx": [
		14293
	],
	"./Auths/thank-you.jsx": [
		86879
	],
	"./billing-success.jsx": [
		61334
	],
	"./customer-reviews.jsx": [
		95088
	],
	"./dashboard.jsx": [
		99268
	],
	"./index.jsx": [
		1793
	],
	"./live-orders.jsx": [
		79887
	],
	"./login.jsx": [
		42950
	],
	"./manage-customers.jsx": [
		48552,
		552
	],
	"./manage-roles.jsx": [
		36337,
		337
	],
	"./manage-stores.jsx": [
		93229
	],
	"./manage-users.jsx": [
		78488,
		488
	],
	"./menu-management.jsx": [
		89094
	],
	"./order-history.jsx": [
		4932
	],
	"./reports.jsx": [
		95256
	],
	"./settings.jsx": [
		22921
	],
	"./store-overview.jsx": [
		26733
	],
	"./template.jsx": [
		1562
	],
	"./website-builder.jsx": [
		99404
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72134;
module.exports = webpackAsyncContext;